export default {
  items: {
    currentMenuIsLoading: false,
    menusItemsAreLoading: false,
    byMenuId: {},
  },
  cart: {
    allIds: [],
    byId: {},
  },
  config: {
    hasConfig: false,
    shouldRefreshConfig: true,
  },
  customer: {
    activeCustomerId: null,
    byId: {},
    requestFailed: false,
  },
  customerPayment: {
    byId: {},
    byCustomerId: {},
    requestFailed: false,
  },
  order: {
    byId: {},
    offlineCardIds: [],
    failureRemoteIds: [],
    unsyncedLocalIds: [],
    unsyncedRemoteIds: [],
    successRemoteIds: [],
    purgedAt: undefined,
    initialPreOrderLoadComplete: false,
    preOrdersAreLoading: false,
    orderDeltasSyncSuccessAt: undefined,
  },
  orderingPreference: {
    byId: {},
    byCustomerId: {},
    requestFailed: false,
  },
  peripheral: {
    peripheralStatus: 'ready'
  },
  refund: {
    byId: {},
    failureRemoteIds: [],
    successRemoteIds: [],
  },
  revenueCenter: {
    byId: {
      'unassigned': {
        uuid: 'unassigned',
        name: 'Unassigned Orders'
      }
    },
    allIds: ['unassigned'],
    activeRevenueCenter: undefined,
  },
  salesEvent: {
    byId: {},
    requestFailed: false,
  },
  categories: {
    byMenuId: {},
  },
  search: {
    showClosedTabs: false,
  }
}
